module.exports = __webpack_public_path__ + "img/placeholder-image.8057445e.png";